import Table from 'components/common/Table'
import React from 'react'

const DELETED_QUERY = { deleted: true }

const Calls = ({ title, endpoint, columnsToSkip }) => {
  return (
    <Table
      key={endpoint}
      paginated
      title={title}
      endpoint={endpoint}
      dataAccessor='calls'
      searchOptions={CALLS_SEARCH_OPTIONS}
      orderOptions={CALLS_ORDER_OPTIONS}
      columnsToSkip={columnsToSkip}
      urlQueries={DELETED_QUERY}
    />
  )
}

const CALLS_SEARCH_OPTIONS = [
  'translatorFullName',
  'translatorEmail',
  'accountFullName',
  'accountEmail',
]
const CALLS_ORDER_OPTIONS = [
  'translatorFullName',
  'translatorEmail',
  'accountFullName',
  'accountEmail',
  'createdAt',
  'endedAt',
]

export default Calls
